import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import SweetAlert2 from 'react-sweetalert2';
import { useForm } from 'react-hook-form';
import apiService from '../../../Auth/apiService';
import { FaUser, FaUsers } from 'react-icons/fa';
import { useAuth } from '../../../Auth/AuthContext';

export default function ConsultarPersona() {
  const navigate = useNavigate();
  const { token } = useAuth();
  const [swalProps, setSwalProps] = useState({});
  const [Cargando, setCargando] = useState(false);
  const {register, handleSubmit, setValue, watch, formState: { errors }} = useForm();
  const [personas, setPersonas] = useState([]);
  const consultarPor = watch('consultarPor');
  const identificacion = watch('identificacion');
  
  const onSubmit = async (data) => {
    setCargando(true);
    try {
      if(consultarPor === 'Documento'){
        const response = await apiService.post('/caracterizacion/consultarporidentificacion', {per_idpersona: data.identificacion}, token);
        const result = await response.data.personas;
        setPersonas(result);
      }else if(consultarPor === 'Nombres'){
        const response = await apiService.post('/caracterizacion/consultarporNombres', {
          per_nombre1: data.nombre1,
          per_nombre2: data.nombre2,
          per_apellido1: data.apellido1,
          per_apellido2: data.apellido2,}, token);
        const result = await response.data;
        setPersonas(result);
      } else if(consultarPor === 'Declaracion'){
        const response = await apiService.post('/caracterizacion/consultarpordeclaracion', {cab_nodeclaracion: data.Declaracion}, token);
        const result = await response.data;
        setPersonas(result);
      } else if(consultarPor === 'Celular'){
        const response = await apiService.post('/caracterizacion/consultarporcelular', {per_celular: data.celular}, token);
        const result = await response.data;
        setPersonas(result);
      }
    } catch (error) {
      Mensaje('Error', 'Ocurrió un error al consultar la persona. ' + (error.response?.data?.message || ''));
      console.error('Error fetching data:', error);
    } finally {
      setCargando(false);
    }
  };

  function handleEdit (row){
    navigate(`/caracterizacion/grupofamiliar/${row.perIdpersona}`);
  };

  const handleUppercase = (event) => {
    const uppercasedValue = event.target.value.toUpperCase();
    const fieldname = event.target.name;
    setValue(fieldname, uppercasedValue);
  };

  const Mensaje = (title, text) => {
    setSwalProps({
      show: true,
      title: title,
      text: text,
  });

  };
  return (
        
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Consultar Persona</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><a href="/">Inicio</a></li>
                        <li className="breadcrumb-item active">Consultar Persona</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section>
              <div className="container-fluid">
                <div className="card card-default">
                    <div className="card-body">
                      <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="row">
                          <div className="col-md-2" >
                            <div className="form-group" >
                              <label htmlFor='consultarPor'>Consultar por</label>
                              <select id='consultarPor' className='form-control' {...register('consultarPor', { required: true })}>
                                <option value="">Seleccionar</option>
                                <option value="Documento">Documento</option>
                                <option value="Nombres">Nombres</option>
                                <option value="Declaracion">Declaracion</option>
                                <option value="Celular">Celular</option>
                              </select>
                              {errors.consultarPor && <p style={{color: 'red'}}>Seleccionar consulta</p>}
                            </div>
                          </div>
                          {consultarPor === 'Declaracion' && <div  className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="Declaracion">Declaracion</label>
                              <input {...register('Declaracion', { validate: value => {
                                    if (consultarPor === 'Declaracion' && !value) {
                                      return 'Digite el código de la declaración';
                                    }
                                    return true;
                                  }
                                })} type="text" className="form-control" />
                              {errors.Declaracion && <p style={{color: 'red'}}>{errors.Declaracion.message}</p>}
                            </div>
                          </div>}
                          {consultarPor === 'Documento' && <div  className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="identificacion">Documento</label>
                              <input {...register('identificacion', { validate: value => {
                                    if (consultarPor === 'Documento' && !value) {
                                      return 'Digite el documento';
                                    }
                                    return true;
                                  }
                                })} type="text" className="form-control" />
                              {errors.identificacion && <p style={{color: 'red'}}>{errors.identificacion.message}</p>}
                            </div>
                          </div>}
                          {consultarPor === 'Nombres' && <div className="col-md-2">
                            <div className="form-group">
                              <label htmlFor="nombre1">Primer nombre</label>
                              <input type="text" {...register('nombre1', { validate: value => {
                                    if (consultarPor === 'Nombres' && !value) {
                                      return 'Digite el primer nombre';
                                    }
                                    return true;
                                  }
                                })} onChange={handleUppercase}  className="form-control" placeholder="Primer nombre"/>
                                {errors.nombre1 && <p style={{color: 'red'}}>{errors.nombre1.message}</p>}
                            </div>
                          </div>}
                          {consultarPor === 'Nombres' && <div className="col-md-2">
                            <div className="form-group">
                              <label htmlFor="nombre2">Segundo nombre</label>
                              <input type="text" {...register('nombre2')} onChange={handleUppercase} className="form-control" placeholder="Segundo nombre"/>
                            </div>
                          </div>}
                          {consultarPor === 'Nombres' && <div  className="col-md-2">
                            <div className="form-group">
                              <label htmlFor="apellido1">Primer apellido</label>
                              <input type="text" {...register('apellido1', { validate: value => {
                                    if (consultarPor === 'Nombres' && !value) {
                                      return 'Digite el primer apellido';
                                    }
                                    return true;
                                  }
                                })} onChange={handleUppercase} className="form-control" placeholder="Primer apellido"/>
                                {errors.apellido1 && <p style={{color: 'red'}}>{errors.apellido1.message}</p>}
                            </div>
                          </div>}
                          {consultarPor === 'Nombres' && <div  className="col-md-2">
                            <div className="form-group">
                              <label htmlFor="apellido2">Segundo apellido</label>
                              <input type="text" {...register('apellido2')} onChange={handleUppercase} className="form-control" placeholder="Segundo apellido"/>
                            </div>
                          </div>}
                          {consultarPor === 'Celular' && <div  className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="celular">N&uacute;mero de celular</label>
                              <input type="text" {...register('celular', { validate: value => {
                                    if (consultarPor === 'Celular' && !value) {
                                      return 'Digite el número de celular';
                                    }
                                    return true;
                                  }
                                })} onChange={handleUppercase} className="form-control" placeholder="N&uacute;mero de celular"/>
                                {errors.celular && <p style={{color: 'red'}}>{errors.celular.message}</p>}
                            </div>
                          </div>}
                        </div>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group">
                              {Cargando && 
                                <button type="submit" className="btn btn-primary" disabled>Consultar</button>}
                              {!Cargando && <button type="submit" className="btn btn-primary">Consultar</button>}
                            </div>
                          </div>
                        </div>
                      </form>
                      
                    </div>
                  </div>
                <section className="content">
                    <div className="container-fluid">
                          {Cargando && <div className="centered">
                            <div><progress value={null} /></div>
                          </div>}
                          
                    </div>
                </section>
                <div className="row">
                    <div className="col-md-12">
                      <div className="card">
                        <div className="card-header">
                          <div className="card-tools">
                            <div className="row">
                              <div className="col-md-12">
                                <button
                                    type="button"
                                    className="btn btn-block btn-primary"
                                    style={{
                                        backgroundColor: 'skyblue',
                                        color: 'black', // Font color black
                                        padding: '6px 12px',         // Smaller padding
                                        fontSize: '1rem',            // Smaller font size
                                        borderRadius: '6px',         // Slightly smaller radius
                                        border: 'none',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                    onClick={() => navigate(`/caracterizacion/persona/0/${identificacion || '0'}/0`)}
                                >
                                    <FaUser /> Crear hogar
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card-body table-responsive p-0">
                          <table className="table table-bordered table-hover">
                              <thead>
                                  <tr>
                                      <th>Acciones</th>
                                      <th>id</th>
                                      <th>Identificación</th>
                                      <th>Primer nombre</th>
                                      <th>Segundo nombre</th>
                                      <th>Primer apellido</th>
                                      <th>Segundo apellido</th>
                                      <th>Nro declaraci&oacute;n</th>
                                      <th>Id Cabeza Familia</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  {personas.length === 0 ? (
                                      <tr>
                                          <td colSpan="7" className="text-center">
                                              La persona no existe en caracterizaci&oacute;n
                                          </td>
                                      </tr>
                                  ) : (
                                      personas.map((row, idx) => (
                                          <tr key={row.id || idx}>
                                              <td>
                                                  <button
                                                      type="button"
                                                      onClick={() => handleEdit(row)}
                                                      style={{
                                                          backgroundColor: 'skyblue',
                                                          padding: '12px 20px',
                                                          fontSize: '1.5rem',
                                                          borderRadius: '8px',
                                                          border: 'none',
                                                          display: 'flex',
                                                          alignItems: 'center',
                                                          justifyContent: 'center'
                                                      }}
                                                      data-tooltip-id='tooltiparriba'
                                                      data-tooltip-content="Ver datos de la persona"
                                                  >
                                                      <FaUsers />
                                                  </button>
                                              </td>
                                              <td>{row.id}</td>
                                              <td>{row.perIdpersona}</td>
                                              <td>{row.perNombre1}</td>
                                              <td>{row.perNombre2}</td>
                                              <td>{row.perApellido1}</td>
                                              <td>{row.perApellido2}</td>
                                              <td>{row.cabNodeclaracion}</td>
                                              <td>{row.idCabezaFamilia}</td>
                                          </tr>
                                      ))
                                  )}
                              </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                <SweetAlert2 {...swalProps} 
                    didClose={() => {
                      setSwalProps({})
                    }}/>
                <Tooltip id="tooltiparriba" place="right"/>
              </div>
            </section>
        </div>
        
        
    )
  }